import cn from "classnames";
import {IReferralRewardsModel, IUser, ReferralRewardsModel, ScoreType} from "@dp-instant/social";
import {TypesSocial} from "@dp-instant/interfaces";
import {lazyGet} from "@dp-instant/core";
import {
    ILeaderboardProps,
    ILeaderobardInviteItemProps,
    ILeaderobardItemProps,
    Reward
} from "@game/ui/interface/ILeaderBoardProps";
import {LeaderBoardItem} from "./LeaderBoardItem";
import {LeaderBoardInviteItem} from "./LeaderBoardInviteItem";
import "./LeaderBoard.less";

const LeaderBoardItemFactory = (item: any) => {
    if (item && item.user) {
        return <LeaderBoardItem {...item} />;
    } else {
        return <LeaderBoardInviteItem {...item} />;
    }
};

const shuffleAndSortLeaderBoardItems = (
    users: ILeaderobardItemProps[] = [],
    invites: ILeaderobardInviteItemProps[] = []
) => {
    users.sort((a, b) => (b.user.score || 0) - (a.user.score || 0));

    users = users.map((item, index) => ({...item, rank: index + 1}));

    return [...users, ...invites];
};

export const LeaderBoard = (props: ILeaderboardProps) => {
    const referrals =
        lazyGet<IReferralRewardsModel<Reward>>(TypesSocial.refRewardsModel)?.getPendingItems() ||
        [];

    const payingRewards =
        lazyGet<ReferralRewardsModel<Reward>>(TypesSocial.refRewardsModel)?.getAvailableItems() ||
        [];

    const getRefReward = (payingRewards: {value: Reward; rf?: string}[], id: string) =>
        payingRewards.filter(r => r.rf === id).map(r => r.value)[0];

    const userScore = (item: IUser, type?: ScoreType) => {
        switch (type) {
            case ScoreType.GLOBAL:
                return item.scoreGlobal;
            case ScoreType.CONTEXT:
                return item.scoreContext;
        }
        return item.scores.getScore();
    };

    // user items
    let users: ILeaderobardItemProps[] = (
        props.users.map((item: IUser) => ({
            name: item.name,
            image_url: item.photo,
            score: userScore(item, props.scoreType),
            reward: getRefReward(payingRewards, item.id),
            origin: item
        })) || []
    ).map(item => ({user: item}));

    // invites
    let invites: ILeaderobardInviteItemProps[] =
        referrals.map(item => ({reward: item.value, pending: !!item.rf})) || [];

    let onClose = props.onClose || (() => {});

    let leaderBoardsItems = shuffleAndSortLeaderBoardItems(users, invites);

    return (
        <>
            <div className={cn("leaderboard")}>
                <ul className={cn("leaderboard__scroll")}>
                    {leaderBoardsItems.map(
                        (item: ILeaderobardInviteItemProps | ILeaderobardItemProps) => {
                            return LeaderBoardItemFactory(item);
                        }
                    )}
                </ul>
            </div>
        </>
    );
};
